export class LanguageEntry {
  public Key: string;
  public Value: string;
}
